"use strict";
/*
Add this script to any pages that use this job board:

<script
  type="text/javascript"
  src="https://boards-api.greenhouse.io/v1/boards/starfaceworld/jobs?callback=getJobs"
></script>

Add this tag to display job listings:

<div id="greenhouse__listings"></div>

*/
function getJobs(data) {
    const listings = document.getElementById("greenhouse__listings");
    if (!listings)
        return;
    listings.replaceChildren();
    if (data.jobs && data.jobs.length >= 1) {
        data.jobs.forEach((job) => {
            const listing = document.createElement("div");
            listing.className = "greenhouse__listing";
            const listingLink = document.createElement("a");
            listingLink.className = "listing__link";
            listingLink.target = "_blank";
            listingLink.rel = "noopener";
            listingLink.href = job.absolute_url;
            const listingRole = document.createElement("p");
            listingRole.className = "listing__role";
            listingRole.textContent = job.title;
            const listingLocation = document.createElement("p");
            listingLocation.className = "listing__location";
            listingLocation.textContent = job.location.name;
            listingLink.appendChild(listingRole);
            listingLink.appendChild(listingLocation);
            listing.appendChild(listingLink);
            listings.appendChild(listing);
        });
    }
    else {
        const noRoles = document.createElement("h3");
        noRoles.textContent = "There are currently no open roles";
        listings.appendChild(noRoles);
    }
}
